import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { FasteignService } from 'src/app/components/services/api/fasteign/fasteign.service';
import { NotandiService } from 'src/app/components/services/api/notandi/notandi.service';
import { formatPhoneNumer } from 'src/app/helpers/formatSsn';
import { AccountsLoginRes } from 'src/app/interfaces/CRUDL/read/AccountsLoginRes';
import { ListPostnumerRes } from 'src/app/interfaces/responses/List/listPostnumerRes';
import { ListSvaediRes } from 'src/app/interfaces/responses/List/listSvaediRes';
import { ReadFasteignasolurRes } from 'src/app/interfaces/responses/Read/readFasteignasolurRes';
import { environment } from 'src/environments/environment';
import { AppService } from '../../app.service';

@Component({
  selector: 'app-properties-for-sale-search',
  templateUrl: './properties-for-sale-search.component.html',
  styleUrls: ['./properties-for-sale-search.component.scss'],

})
export class PropertiesForSaleSearchComponent implements OnInit {

  public isBrowser: boolean;
  public isServer: boolean;

  public fileServiceUrl = environment.fileServiceUrl;

  userDetails: AccountsLoginRes;

  @Input() isHomePage: boolean = false;
  @Input() variant: number = 1;
  @Input() vertical: boolean = false;

  @Output() onSearchClick: EventEmitter<any> = new EventEmitter<any>();
  @Input() form: UntypedFormGroup;

  @Input() fasteignasala: ReadFasteignasolurRes;

  // Listi yfir hluti sem hægt er að nota í filtering.
  // Sótt frá vefþjónustu.
  public postnumer: Array<ListPostnumerRes>;
  public svaedi: Array<ListSvaediRes>;

  verdOptions: Array<number> = [
    10,
    20,
    30,
    40,
    50,
    60,
    70,
    80,
    90,
    100,
    110,
    120,
    130,
    140,
    150,
    160,
    170,
    180,
    190,
    200
  ]

  flytimerktarSearch() {
    if (this.userDetails) {
      this.search();
    } else {
      window.location.href = environment.portalUrl + "/fasteignir/til-solu/syna-adeins-flytimerktar";
    }
  }

  public search(forceSearch = false) {
    if (!this.isHomePage || forceSearch) {
      this.onSearchClick.emit(this.form);
    }
    if (this.isHomePage) {
      // Þegar notandi er á forsíðu og er að leita eftir fasteignum til sölu þarf að passa að
      // við tökum af hakið flýtimerktar því við viljum ekki aðeins sía eftir flýtimerktum.
      this.form.get("flytimerktar").setValue(false);
      localStorage.setItem("_tilSoluFilterForm", JSON.stringify(this.form.value));
    }
  }

  public getAppearance() {
    return (this.variant != 3) ? 'outline' : '';
  }

  public getFloatLabel() {
    return (this.variant == 1) ? 'always' : '';
  }

  // --------------------------- INIT ------------------------------------------------------------
  constructor(public appService: AppService, public fb: UntypedFormBuilder, public dialog: MatDialog, public fasteignService: FasteignService, @Inject(PLATFORM_ID) platformId: Object, private notandiService: NotandiService) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.isServer = isPlatformServer(platformId);

    if (this.isBrowser) {
      try {
        this.notandiService.userDetails.subscribe(userDetails => this.userDetails = userDetails);
      } catch { }
    }
  }

  ngOnInit() {
    if (this.isBrowser) {
      this.saekjaSvaedi();
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // -------------------------------- HTTP Köll ----------------------------------------------------------

  saekjaSvaedi() {
    this.fasteignService.listSvaedi().subscribe(res => {
      this.svaedi = res.filter(x => x.svaedi.length > 0);
    });
  }

  //#region Helper functions

  formatPhoneNumer(phone: string) {
    return formatPhoneNumer(phone);
  }

  //#endregion

}
